import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'gymfinder-gym-image-preview',
  templateUrl: './gym-image-preview.component.html',
  styleUrls: ['./gym-image-preview.component.scss'],
  standalone: false,
})
export class GymImagePreviewComponent {
  @Input()
  src: string;

  @Input()
  isMainPicture?: boolean;

  @Output()
  selectMainPicture = new EventEmitter<void>();

  @Output()
  deleteImage = new EventEmitter<void>();

  public onDeleteButtonClick() {
    this.deleteImage.emit();
  }

  public onSelectMainPicture() {
    this.selectMainPicture.emit();
  }
}
